module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/label_adoption.92250.png";